export default __webpack_public_path__ + "static/media/companiesLogo.b13e7ecf.png";